import { createTheme } from '@mui/material/styles';
import overrides from './overrides';
import palette from './palette';
import typography from './typography';

const theme = createTheme({
  metrics: {
    fontSize: '2rem',
    headerHeight: '3rem',
  },
  components: {
    ...overrides,
  },
  typography: {
    ...typography,
  },
  palette: {
    ...palette,
  },
});

export default theme;
